module.exports = __webpack_public_path__ + "media/images/alarme-3405fc7b747ecc95364dc0bfe193d851.svg";